import React from 'react';
import { Zap } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBanner() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(36000);
  return <div className="sticky top-0 z-50 w-full bg-red-600 text-white py-3 px-4 shadow-lg border-b-2 border-red-800/40" data-id="element-261">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-sm md:text-base text-center" data-id="element-262">
        <div className="flex items-center gap-2 font-semibold" data-id="element-263">
          <Zap className="w-5 h-5 text-yellow-300 animate-pulse" data-id="element-264" />
          <span className="tracking-wide" data-id="element-265">
            OFERTA ESPECIAL POR TIEMPO LIMITADO
          </span>
        </div>

        <div className="flex items-center gap-2" data-id="element-266">
          <span className="opacity-80" data-id="element-267">— Termina en:</span>
          <div className="flex items-center gap-1" data-id="element-268">
            <span className="font-mono font-bold bg-white/15 px-2.5 py-1 rounded-lg" data-id="element-269">
              {hours}
            </span>
            <span className="font-bold text-yellow-300" data-id="element-270">:</span>
            <span className="font-mono font-bold bg-white/15 px-2.5 py-1 rounded-lg" data-id="element-271">
              {minutes}
            </span>
            <span className="font-bold text-yellow-300" data-id="element-272">:</span>
            <span className="font-mono font-bold bg-white/15 px-2.5 py-1 rounded-lg" data-id="element-273">
              {seconds}
            </span>
          </div>
        </div>

        <div className="font-medium" data-id="element-274">
          <span className="opacity-60 line-through mr-2" data-id="element-275">49,99€</span>
          <span className="text-yellow-300 font-bold" data-id="element-276">HOY SOLO: 19,99€</span>
        </div>
      </div>
    </div>;
}